import { FC } from 'react'
import s from './socials.module.scss'
import { Button } from '@components/UIKit/Button/Button'
import { signIn } from 'next-auth/react'
import { SpriteIcon } from '@components/Sprites/SpriteIcon'
import { api } from '@api'
import { useRouter } from 'next/router'
import { LinksEnum } from '@specs/navigation'

interface Props {
    isChecked: boolean
    isDisabled: boolean
}

export const Telegram: FC<Props> = ({ isChecked, isDisabled }) => {
    const router = useRouter()

    const { mutateAsync: tgCredentials } = api.UserManager.getCredentialsTelegramAuth.useMutation({
        mutationKey: ['UserManager.getCredentialsTelegramAuth'],
        onSuccess: async (res) => {
            if (res) {
                await signIn('telegram', { tgUserId: res.tgUserId, firstName: res.firstName, redirect: true }).then(async (value) => {
                    if (!value?.ok) await router.push(LinksEnum.SIGN_IN_ERROR)
                })
            }
        },
    })

    const { mutateAsync: authTelegramLink } = api.UserManager.getAuthLinkTelegram.useMutation({
        mutationKey: ['UserManager.getAuthLinkTelegram'],
        onError: async () => {
            await router.push(LinksEnum.SIGN_IN_ERROR)
        },
        onSuccess: (data) => {
            async function executeSignIn() {
                tgCredentials({ uidLoginTelegram: data.uid })
            }

            setInterval(executeSignIn, 3000)
        },
    })

    const telegramClickHandler = async () => {
        const { url } = await authTelegramLink()
        // Без setTimeout не работает в мобильном сафари
        setTimeout(() => {
            window.open(url, '_blank', 'noreferrer')
        })
    }


    return (
        <Button
            id='telegram_main_button'
            className={s.socials__button}
            size={'large'}
            color={'White'}
            onClick={telegramClickHandler}
            disabled={isDisabled || !isChecked}
        >
            <SpriteIcon
                name={'telegram'}
                width={20}
                height={20}
            />
        </Button>
    )
}
